import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import Badge from "react-bootstrap/Badge";
import {
  FormOutlined,
  ZoomInOutlined,
  EditOutlined,
  MinusCircleOutlined,
  DownloadOutlined,
  HistoryOutlined,
  CheckOutlined
} from "@ant-design/icons";
import "./PregledTable.css";
import { Tooltip } from "antd";

const DrustvaTable = (props) => {

  let registarLabel = "";
  let nazivLabel = "";
  let vrDrustva;

  if (props.formId == 2) {
    registarLabel = "REGISTAR REVIZORSKIH DRUŠTAVA";
    nazivLabel = "Naziv revizorskog društva";
    vrDrustva = 1;
  } else if (props.formId == 3) {
    registarLabel = "REGISTAR SAMOSTALNIH REVIZORA";
    nazivLabel = "Ime i prezime samostalnog revizora";
    vrDrustva = 2;
  } else if (props.formId == 5) {
    registarLabel = "REGISTAR REVIZORSKIH DRUŠTAVA IZ DRUGIH DRŽAVA ČLANICA";
    nazivLabel = "Naziv revizorskog društva";
    vrDrustva = 3;
  } else if (props.formId == 7) {
    registarLabel =
      "REGISTAR SUBJEKATA ZA OBAVLJANJE REVIZIJE U TREĆOJ ZEMLJI I REGISTAR REVIZORA U TREĆOJ ZEMLJI";
    nazivLabel =
      "Naziv revizorskog društva / ime i prezime samostalnog revizora";
    vrDrustva = 4;
  }

  const poruka =
    props.children && props.children.length == 0 ? (
      <div style={{ textAlign: "center", marginTop: "0px" }}>
        <p className="search-result-text">Zadana pretraga nema rezultata.</p>
      </div>
    ) : null;

  const { userRole } = props;

  const checkIfUserIsAdmin =
    userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

  return (
    <>
      {props.children && props.children.length != 0 ? (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            marginBottom: ".5rem",
          }}
        >
          <h5
            style={{
              lineHeight: "1.2",
              margin: "0 8px 0",
            }}
          >
            {registarLabel}
          </h5>

          <Tooltip title="Preuzmi registar u CSV">
            <ButtonComponent
              className="download_csv"
              onClick={(e) =>
                props.exportRegistar("drustvo", vrDrustva, registarLabel)
              }
              variant="secondary"
            >
              <DownloadOutlined />
            </ButtonComponent>{" "}
          </Tooltip>
        </div>
      ) : null}{" "}
      {poruka}
      <Table responsive bordered hover>
        <thead>
          {props.children && props.children.length != 0 ? (
            <tr className="tr_table">
              <th scope="col">{nazivLabel}</th>
              <th scope="col">Registarski broj</th>
              {props.formId != 5 ? <th scope="col">OIB</th> : null}
              {props.formId == 5 ? <th scope="col">Država</th> : null}
              <th scope="col">Detalji</th>
              {checkIfUserIsAdmin ? (
                <Fragment>
                  <th scope="col">Povijest</th>
                  <th scope="col">Ažuriraj bez zahtjeva</th>
                  <th scope="col">Ažuriraj po zahtjevu</th>
                  <th scope="col">Akcija</th>
                  <th scope="col">Status</th>
                </Fragment>
              ) : null}
            </tr>
          ) : null}
        </thead>
        <tbody>
          {props.children &&
            props.children.map(
              (element) =>
                ((!props.isAuthenticated && element.drustvo.oznAkt == "1") ||
                  (props.userRole === "ROLE_KORISNIK" &&
                    element.drustvo.oznAkt == "1") ||
                  checkIfUserIsAdmin) && (
                  <tr key={element.drustvo.idDrustva}>
                    <td>
                      {element.drustvo.nazDrustva
                        ? element.drustvo.nazDrustva
                        : element.drustvo.ime + " " + element.drustvo.prezime}
                    </td>
                    <td>{element.drustvo.regBroj}</td>
                    {props.formId != 5 ? <td x-ms-format-detection="none">{element.drustvo.oib}</td> : null}
                    {props.formId == 5 ? (
                      <td>{element.drustvo.nazDrzave}</td>
                    ) : null}
                    <td className="ant_batn">
                      <ButtonComponent
                        variant="secondary"
                        onClick={(e) =>
                          props.detaljiClicked(
                            element.drustvo.idDrustva,
                            element.drustvo.vrDrustva,
                            "drustvo",
                            false
                          )
                        }
                      >
                        <ZoomInOutlined />
                      </ButtonComponent>
                    </td>
                    {checkIfUserIsAdmin ? (
                      <Fragment>
                        <td className="ant_batn">
                          <ButtonComponent
                            disabled={element.drustvo.oznAkt === 2}
                            variant="secondary"
                            onClick={(e) =>
                              props.povijestClicked(
                                element.drustvo.regBroj,
                                "drustvo"
                              )
                            }
                          >
                            <HistoryOutlined />
                          </ButtonComponent>
                        </td>
                        <td className="ant_batn">
                          <ButtonComponent
                            variant="secondary"
                            onClick={(e) =>
                              props.redirectHandler(
                                e,
                                element.drustvo.idDrustva,
                                element.drustvo.vrDrustva
                              )
                            }
                            disabled={
                              element.drustvo.oznAkt == 2 ? true : false
                            }
                          >
                            <EditOutlined />
                          </ButtonComponent>
                        </td>
                        <td className="ant_batn">
                          <ButtonComponent
                            variant="secondary"
                            onClick={(e) =>
                              props.azurirajClicked(
                                e,
                                element.drustvo.idDrustva,
                                element.drustvo.vrDrustva,
                                element.drustvo.regBroj
                              )
                            }
                            disabled={
                              element.drustvo.oznAkt == 2 ? true : false
                            }
                          >
                            <FormOutlined />
                          </ButtonComponent>
                        </td>
                        {element.drustvo.oznAkt == 2 ? (
                        <td className="aktivirajButton ant_batn">
                          <Tooltip title="Aktiviraj subjekt">
                          <ButtonComponent
                            onClick={(e) =>
                              props.aktivirajClicked(
                                "drustvo",
                                element.drustvo.idDrustva
                              )
                            }
                            //disabled={element.drustvo.oznAkt == 2 ? true : false}
                            variant="secondary"
                            // style={{backgroundColor:"#dc3545", border:"none", color:"white"}}
                          >
                            <CheckOutlined />
                          </ButtonComponent>  {" "}
                          </Tooltip>
                        </td> ) : (
                        <td className="disableButton ant_batn">
                          <Tooltip title="Deaktiviraj subjekt">
                          <ButtonComponent
                            onClick={(e) =>
                              props.deaktivirajClicked(
                                "drustvo",
                                element.drustvo.idDrustva,
                                element.drustvo.vrDrustva
                              )
                            }
                           // disabled={element.drustvo.oznAkt == 2 ? true : false}
                            variant="secondary"
                            // style={{backgroundColor:"#dc3545", border:"none", color:"white"}}
                          >
                            <MinusCircleOutlined />
                          </ButtonComponent>  {" "}
                          </Tooltip>
                        </td>)}
                        <td>
                          {element.drustvo.oznAkt == 1 ? (
                            <Badge pill variant="success">
                              Aktivan
                            </Badge>
                          ) : (
                            <Badge pill variant="danger">
                              Brisan
                            </Badge>
                          )}
                        </td>
                      </Fragment>
                    ) : null}
                  </tr>
                )
            )}
        </tbody>
      </Table>
    </>
  );
};

export default DrustvaTable;
